<template>
  <ModalMenu class-name="web_push_modal" :is-teleport-enabled="true" :background-scroll="false">
    <template #title>
      <a href="#" class="web_push_modal-close" data-test-id="btn_close" @click.prevent="close">
        <i class="icon icon-close"></i>
      </a>

      <div class="mx-auto mb-32 text-center">
        <img src="../../assets/img/easy-start-pack/credits-2.png" width="88" height="88" alt="" />
      </div>

      <span class="text-warning">{{ credits.value ?? 0 }} {{ t('credits') }}</span>
      <br />
      {{ t('header') }}
    </template>
    <template #text>
      <div v-if="!isOrganic" class="web_push_modal-content text-body2 font-normal">
        {{ t('sendSomeone') }}
      </div>

      <button type="button" class="btn btn-primary btn-block" @click="close">
        {{ t('gotIt') }}
      </button>
    </template>
  </ModalMenu>
</template>

<script lang="ts">
// these params are necessary for modal service
export default { isPaymentModal: true };
</script>

<script lang="ts" setup>
import { computed, Ref } from 'vue';

import ModalMenu from '@/components/modal/modal-menu/ModalMenu.vue';
import { useI18n } from '@/services/i18n';
import { getState } from '@/store/store-helper';

import { messages } from './i18n';

type Props = {
  credits: Ref<number>;
};

defineProps<Props>();

const emit = defineEmits(['close']);

const { t } = useI18n({ messages });

const isOrganic = computed(() => getState().common.index.isOrganic);

function close(): void {
  emit('close');
}
</script>
